module.exports = __webpack_public_path__ + "static/media/patrick_zhou.12d7078e.png";